import React, { useState, useRef, useEffect } from "react";
import "../Bfsi Solution/faq.css";

const Faq = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const answerRefs = useRef([]);

  const faqs = [
    {
      q: "What Services Does Your Healthcare Software Development Company Offer?",
      a: "We specialize in custom healthcare software development, including EMR/EHR systems, telemedicine solutions, medical billing software, and more.",
    },
    {
      q: "How Experienced is Your Team in Healthcare Software Development?",
      a: "Our team comprises seasoned professionals with extensive experience in developing healthcare solutions, ensuring expertise in compliance, security, and industry-specific requirements.",
    },
    {
      q: "Can You Customize Software Solutions to Meet Our Specific Needs?",
      a: "Absolutely. We tailor our healthcare software to match the unique requirements of each client, ensuring seamless integration with existing systems and workflows.",
    },
    {
      q: "What Security Measures Do You Implement to Protect Patient Data?",
      a: "We prioritize the highest standards of security, incorporating encryption, access controls, and compliance with HIPAA and other relevant regulations to safeguard patient data.",
    },
    {
      q: "How Do You Ensure Compliance With Healthcare Industry Standards and Regulations?",
      a: "Our development processes strictly adhere to industry standards, including HIPAA, HL7, and other regulatory frameworks, to ensure compliance and mitigate legal risks.",
    },
    {
      q: "What Technologies Do You Use for Healthcare Software Development?",
      a: "We leverage cutting-edge technologies, including AI, blockchain, and interoperability standards, to develop innovative and scalable healthcare software solutions.",
    },
    {
      q: "How Do You Handle Interoperability Challenges in Healthcare Software Development?",
      a: "Our team is adept at integrating healthcare software with existing systems, ensuring seamless data exchange and interoperability across various platforms.",
    },
    {
      q: "What is the Typical Timeline for Healthcare Software Development Projects?",
      a: "Project timelines vary based on the complexity and scope. We work closely with clients to establish realistic timelines and provide regular updates throughout the development process.",
    },
    {
      q: "How Do You Handle Software Updates and Maintenance?",
      a: "We offer ongoing support, including regular updates, maintenance, and troubleshooting to ensure the continued efficiency and reliability of your healthcare software.",
    },
    {
      q: "Can You Provide References or Case Studies From Previous Healthcare Software Projects?",
      a: "Certainly. We can share references and case studies that showcase our successful implementations in healthcare software development.",
    },
  ];

  const toggleFaq = (index) => {
    setActiveIndex(index === activeIndex ? null : index);
  };

  // Get height for smooth animation
  const getHeight = (index) => {
  const el = answerRefs.current[index];
  if (!el) return "0px";

  const padding = 40; // top 20 + bottom 20
  return `${el.scrollHeight + padding}px`;
};


  return (
    <div className="faq-wrapper">
      <h2 className="faq-title">Faq's</h2>

      {faqs.map((item, index) => (
        <div
          className={`faq-item ${activeIndex === index ? "active" : ""}`}
          key={index}
        >
          <div className="faq-question" onClick={() => toggleFaq(index)}>
            <span>{item.q}</span>
            <span className="faq-icon">
              {activeIndex === index ? "−" : "+"}
            </span>
          </div>

          {/* Smooth answer */}
          <div
            className="faq-answer"
            ref={(el) => (answerRefs.current[index] = el)}
            style={{
              maxHeight: activeIndex === index ? getHeight(index) : "0px",
            }}
          >
            <p>{item.a}</p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default Faq;
